import React from "react";
import { StaticFooter } from ".";
import LanguageSelectionDropDown from "../LanguageDropDown";
import { SupplierLogoContainer } from "../MainApp";

export default function TrifectaCover(props) {
  return (
    <>
      <SupplierLogoContainer />
      <LanguageSelectionDropDown />
      <div className="static-page-contain">{props.children}</div>
      <StaticFooter parent="footer-pay-complete" />
    </>
  );
}
